import PropTypes from 'prop-types';
import React from 'react';
import useShare from '../../Hooks/useShare';
import useWindowLocationHref from '../../Hooks/useWindowLocation';

const ShareButton = ({
  description,
  buttonText = 'Dela sidan',
  link,
  requireLink = true,
  title,
  copiedToClipboardMessage,
  trackCategory,
  trackAction,
  trackName,
}) => {
  const href = useWindowLocationHref();
  const { share, copiedToClipboard } = useShare();

  const handleShare = async () => {
    await share({
      title: title,
      text: description,
      url: link,
    });
  };

  const textToDisplay =
    copiedToClipboard && copiedToClipboardMessage
      ? copiedToClipboardMessage
      : buttonText;

  if (requireLink && !link) {
    return null;
  }

  return (
    <button
      data-event-category={trackCategory || href || 'novalue'}
      data-event-action={trackAction || title}
      data-event-value={link || href || 'novalue'}
      data-event-name={trackName || 'Dela knapp'}
      className="c-share-button"
      onClick={handleShare}
      data-matomo-id="share-button"
    >
      <i className="c-share-button__icon" aria-hidden="true"></i>
      <span data-event-include aria-live="polite">
        {textToDisplay}
      </span>
    </button>
  );
};

ShareButton.propTypes = {
  link: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  title: PropTypes.string,
  copiedToClipboardMessage: PropTypes.string,
};

export default ShareButton;
